/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsChannelMappingModel>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelMapping/getAll`, {
      method: "GET",

      ...options,
    }),
  );
}
